import QuestionModel from "../QuestionModel";
import QuestionValue from "../QuestionValue";
import QuestionValueRoman from "../QuestionValueRoman";
import QuestionModule from "./QuestionModule";
import QuestionModuleArithmetic from "./QuestionModuleArithmetic";

export default class QuestionModuleArithmeticRoman extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);

        let result = 0;

        if (question.type !== QuestionModel.TYPE_DIVISION) {
            for (let i = 0; i < data.values - 1; ++i) {
                const n = P3.math.randomInt(data.range.min, data.range.max);
                question.values.push(new QuestionValueRoman(n));

                if (i === 0) result = n;
                else {
                    switch (data.type) {
                        case QuestionModel.TYPE_ADDITION        : {
                            result += n;
                            break;
                        }
                        case QuestionModel.TYPE_SUBTRACTION     : {
                            result -= n;
                            break;
                        }
                        case QuestionModel.TYPE_MULTIPLICATION  : {
                            result *= n;
                            break;
                        }
                        // case QuestionModel.TYPE_DIVISION        : {result = Math.round(result / n); break;}
                    }
                }
            }
        } else {
            //TODO - this should be of any length but at time being I can't think of a nice way to extend it
            //division requires a special case in order to avoid fractional answers
            result = P3.math.randomInt(data.range.min, data.range.max);
            const secondTerm = P3.math.randomInt(data.range.min, data.range.max);
            const firstTerm = result * secondTerm;
            question.values.push(new QuestionValueRoman(firstTerm));
            question.values.push(new QuestionValueRoman(secondTerm));
        }

        question.values.push(new QuestionValueRoman(result));

        if (question.view !== QuestionModel.VIEW_STATEMENT_MULTI) {
            question.part = typeof data.parts === "number" ? data.parts : P3.utils.selectRandom(P3.utils.objectToArray(data.parts));
        } else {
            //for multi questions ensure we pick two slots
            question.part = [];
            const arr = P3.utils.objectToArray(data.parts);
            let rand = P3.math.randomInt(0, arr.length - 1);
            question.part.push(arr[rand]);
            arr.splice(rand, 1);
            rand = P3.math.randomInt(0, arr.length - 1);
            question.part.push(arr[rand]);
        }
        question.options = this.generateOptions(question, data.options || 5);
        question.xp = data.xp;

        return question;
    }

    generateOptions(question, count = 5) {
        let k = 1000;
        const options = [question.answer];
        switch (question.type) {
            case QuestionModel.TYPE_ADDITION : {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = 0;
                        const max = question.range.max;
                        switch (P3.math.randomInt(0, 1)) {
                            default :
                            case 0 :
                                return question.answer.value + P3.math.randomInt(min, max);
                                /*
                            case 1 :
                                return question.answer.value + P3.math.randomInt(min, max) * 10;
                            case 2 :
                                return question.answer.value * 10;
                                */
                        }
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValueRoman(value));
                }
                break;
            }
            case QuestionModel.TYPE_SUBTRACTION : {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Math.min(-10, -question.answer * 2);
                        const max = Math.max(10, question.answer * 0.5);
                        return question.answer.value + P3.math.randomInt(min, max);
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValueRoman(value));
                }
                break;
            }
            case QuestionModel.TYPE_MULTIPLICATION : {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Math.min(question.range.min, -question.answer);
                        const max = Math.max(question.range.max, question.answer);
                        switch (P3.math.randomInt(0, 1)) {
                            default :
                            case 0 :
                                return question.answer.value + P3.math.randomInt(min, max);
                                /*
                            case 1 :
                                return question.answer.value + P3.math.randomInt(min, max) * 10;
                            case 2 :
                                return question.answer.value * 10;
                                */
                        }
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValueRoman(value));
                }
                break;
            }
            case QuestionModel.TYPE_DIVISION : {
                while (options.length < count && k-- > 0) {
                    const value = (() => {
                        const min = Math.min(question.range.min, -question.answer);
                        const max = Math.max(question.range.max, question.answer);
                        switch (P3.math.randomInt(0, 1)) {
                            default :
                            case 0 :
                                return question.answer.value + P3.math.randomInt(min, max);
                                /*
                            case 1 :
                                return question.answer.value + P3.math.randomInt(min, max) * 10;
                            case 2 :
                                return question.answer.value * 10;
                                */
                        }
                    })();
                    options.every(x => x.value !== value) && options.push(new QuestionValueRoman(value));
                }
            }
        }
        P3.utils.shuffleArray(options);
        return options;
    }
}